import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

const ProductName = () => {
  return (
    <Flex align="baseline" gap={2}>
      <Text
        fontSize="xl"
        fontWeight="bold"
        color="#17458f"  // Rotary blue color
        lineHeight="shorter"
      >
        RoText™
      </Text>
      <Text
        fontSize="sm"
        color="gray.500"
        lineHeight="shorter"
      >
        Rotary Text Messaging
      </Text>
    </Flex>
  );
};

export default ProductName;
